<template>
  <div class="vue-modal border-b">
    <div id="authentication-modal" @click.self="SET_SHOW_MODAL_SEARCH(false)" tabindex="-1" aria-hidden="true" 
      class="w-full backdrop-blur-sm flex bg-gray-200 bg-opacity-50 overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-[99] md:inset-0 h-modal mt-[5.5em] md:h-full items-center">
      <div class="flex items-center relative w-full max-w-md h-[100vh]">
        <div class="relative bg-white shadow">
          <button @click="SET_SHOW_MODAL_SEARCH(false)" type="button" class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 text-sm p-1.5 ml-auto inline-flex items-center" data-modal-toggle="authentication-modal">
            <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
          </button>
          <div v-if="getShowModalSearch" class="top-0  w-full transition-transform fixed bg-white z-[99] border">
            <Sugestoes />
            <section v-if="getLoadingAulaSearch" class="flex w-full justify-between overflow-hidden">
                <div v-for="(loading, index) in 8" :key="index" class="w-full mx-2 min-w-[380px]">
                  <VideoSkeleton />
                </div>
            </section>
            <section v-else class="py-5">
                <Carousel v-if="!getLoadingAulaSearch && getAulasPesquisada.length > 0" v-bind="settings" :breakpoints="breakpoints" :transition="500">
                  <slide v-for="aula in getAulasPesquisada" :key="aula.id">
                    <router-link :to="'/aula/' + aula.id" @click="SET_SHOW_MODAL_SEARCH(false)" class="px-2 w-full">
                      <SingleVideoComponent :aula="aula" />
                    </router-link>
                  </slide>
                  <template #addons>
                    <Navigation />
                  </template>
                </Carousel>
                <section v-if="getAulasPesquisada.length == 0" class="text-center w-full p-5 text-gray-400">
                  Nenhum resultado encontrado
                  <p class="text-xs">
                    Utilize palavras-chave diferentes.
                  </p>
                </section>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import VideoSkeleton from '@/components/VideoSkeletonComponent.vue';
  import Sugestoes from '@/components/search/Sugestoes.vue';
  import SingleVideoComponent from '@/components/SingleVideoComponent.vue';
  import 'vue3-carousel/dist/carousel.css'
  import { Carousel, Slide, Navigation } from 'vue3-carousel';

  export default {
    name: 'Modal_SearchComponent',
    components: {
          VideoSkeleton,
          Sugestoes,
          SingleVideoComponent,
          Carousel,
          Slide,
          Navigation
        },
    data() {
      return {
        settings: {
          itemsToShow: 1.1,
          snapAlign: 'center',
        },
        breakpoints: {
          580: {
              itemsToShow: 1.8,
              snapAlign: 'start',
          },
          700: {
              itemsToShow: 2.2,
              snapAlign: 'start',
          },
          880: {
              itemsToShow: 2.5,
              snapAlign: 'start',
          },
          1000: {
              itemsToShow: 2.8,
              snapAlign: 'start',
          },
          1200: {
              itemsToShow: 3.2,
              snapAlign: 'start',
          },
          1440: {
              itemsToShow: 4.2,
              snapAlign: 'start',
          },
          1800: {
              itemsToShow: 5.2,
              snapAlign: 'start',
          },
          2560: {
              itemsToShow: 6.2,
              snapAlign: 'start',
          }
        }
      }
    },
    methods: {
      ...mapActions(['loginUserAPI', 'fetchBusca']),
      ...mapMutations(['SET_SHOW_MODAL_SEARCH']),
    },
    computed: {
      ...mapGetters(['getSubjects', 'getAulasPesquisada', 'getLoadingAulaSearch', 'getShowModalSearch']),
    },
    async mounted() {
      await this.fetchBusca({
          keyword: this.$store.state.aulas.keyword.trim(), 
          pageNumber: this.page
      })
    }
  }
</script>

<style >
  .carousel__item {
    min-height: 200px;
    width: 100%;
    background-color: var(--vc-clr-primary);
    color: var(--vc-clr-white);
    font-size: 20px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .carousel__slide {
    padding: 1px;
  }

  .carousel__prev,
  .carousel__next {
    height: 100%!important;
    width: 50px!important;
    margin: 0!important;
    box-sizing: content-box;

  }
  .carousel__next--disabled, 
  .carousel__prev--disabled {
      display: none!important;
      opacity: 0!important;
  }
  .carousel__icon{
    color: white;
    background-color: rgba(0,0,0,.3);
  }
</style>